/* eslint-disable  react/jsx-boolean-value */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  LoanDetailCardWrapper,
  LoanDetailsTitle,
  HR,
  LoanPaidOffSuccess,
  TransactionHistoryLink,
  PaidOffMessage,
  Overview,
  PaymentWrapper,
  TransactionAndBankInfoWrapper,
  PaidOffWrapper,
  PaidOffTitle,
} from './LoanDetailCard.styles';
import type { RootState } from '../../../store/configureStore';
import VehicleDetails from '../../future-packages/vehicle-details';
import CurrentPayment from './current-payment';
import ScheduledPayments from './scheduled-payments';
import TransactionHistoryCard from '../../transaction-history/transaction-history-card';
import ConfettiCannonIcon from '../../../assets/ConfettiCannonIcon';
import BankInformation from '../../bank-information/BankInformation';
import LoanOverview from './loan-overview';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const LoanDetailCard = (props: { vehicleId: any }) => {
  const { trackEvent } = useDualEventTracking();
  const { vehicleId } = props;
  // Get Updated on successful dispatch
  const myCars = useSelector((state: RootState) => state.myCars.cars);

  // My Cars - Loan Details used in Render
  const loanDetailCar: any = myCars.find(
    (carItem: any) => carItem.vehicle.vehicleId === Number(vehicleId)
  );

  // this is cased different than the other sections that use this constant.
  // data is fetched from purchases endpoint and it is returning paidOffLoan vs
  // loanservicing as PaidOffLoan.  //TODO update this back to use the constant
  // when the api is updated. cltv/mycars/api/v3/purchases
  const isPaidInFull = loanDetailCar?.loanDetails?.loanState === 'PaidOffLoan';

  useEffect(() => {
    if (isPaidInFull) {
      trackEvent('PaidOff Screen');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLinkClick = () => {
    trackEvent('v2_loan_details_view_all_transactions_button_tap');
  };

  const {
    currentLoanBalance,
    isProcessed,
    principalPaid,
    isPastDue,
  } = loanDetailCar.loanDetails;

  const loanOverviewData = {
    currentLoanBalance,
    isProcessed,
    principalPaid,
    isPastDue,
  };

  return (
    <LoanDetailCardWrapper>
      <LoanDetailsTitle>Loan Details</LoanDetailsTitle>
      <Overview>
        <VehicleDetails myCar={loanDetailCar.vehicle} isOverviewCard={true} />

        {!isPaidInFull && loanOverviewData.isProcessed && (
          <>
            <HR />
            <LoanOverview loanOverviewData={loanOverviewData} />
          </>
        )}
      </Overview>
      {isPaidInFull && (
        <PaidOffWrapper>
          <PaidOffTitle>You&apos;re all set! </PaidOffTitle>
          <LoanPaidOffSuccess>
            <ConfettiCannonIcon />
            <PaidOffMessage>
              Congratulations, your Bridgecrest account has been paid off!{' '}
            </PaidOffMessage>
          </LoanPaidOffSuccess>
          <TransactionHistoryLink
            to={`/loan-detail/transaction-history/${vehicleId}`}
            onClick={handleLinkClick}
          >
            See Transaction History
          </TransactionHistoryLink>
        </PaidOffWrapper>
      )}
      {!isPaidInFull && (
        <PaymentWrapper>
          <CurrentPayment loanDetailCar={loanDetailCar} />
          <HR />
          <ScheduledPayments vehicleId={vehicleId} />
        </PaymentWrapper>
      )}
      <TransactionAndBankInfoWrapper>
        {!isPaidInFull && <TransactionHistoryCard vehicleId={vehicleId} />}
        {loanDetailCar && (
          <BankInformation
            vehicleId={vehicleId}
            bankAccounts={loanDetailCar.bankInfo}
            updateBankTrackEvent="loan_details_edit_bank_button_tap"
            isPaidInFull={isPaidInFull}
            isHalfView={true}
          />
        )}
      </TransactionAndBankInfoWrapper>
    </LoanDetailCardWrapper>
  );
};

export default LoanDetailCard;
